// Stock On Hand report i18n keys (used by StockOnHandReport.vue).
// Page-level keys live under `StockOnHandReport.*`.

export const reportStockOnHandDict: Record<string, [en: string, th: string]> = {
  // ── Page-level keys ──────────────────────────────────────
  "StockOnHandReport.breadcrumb": ["Stock On Hand", "รายงานสต็อกคงเหลือ"],

  // ── Summary cards ───────────────────────────────────────
  "StockOnHandReport.summary.totalBottles": ["Total Bottles", "ขวดทั้งหมด"],
  "StockOnHandReport.summary.inStock": ["In Stock", "คงเหลือในคลัง"],
  "StockOnHandReport.summary.checkedOut": ["Checked Out", "ถูกนำออก"],
  "StockOnHandReport.summary.lost": ["Lost", "สูญหาย"],
  "StockOnHandReport.summary.rfidTagged": ["RFID Tagged", "ติดแท็ก RFID แล้ว"],
  "StockOnHandReport.summary.stockValue": ["Stock Value", "มูลค่าสต็อก"],

  // ── Search & filters ─────────────────────────────────────
  "StockOnHandReport.search": ["Search by wine, producer, or region", "ค้นหาจากชื่อไวน์ ผู้ผลิต หรือแหล่งผลิต"],
  "StockOnHandReport.filter.location": ["Location", "ตำแหน่ง"],
  "StockOnHandReport.filter.type": ["Beverage type", "ประเภทเครื่องดื่ม"],
  "StockOnHandReport.filter.category": ["Category", "หมวดหมู่"],
  "StockOnHandReport.filter.status": ["Stock status", "สถานะสต็อก"],
  "StockOnHandReport.filter.rfidTag": ["RFID tag", "แท็ก RFID"],

  // ── Stock status options ─────────────────────────────────
  "StockOnHandReport.status.inStock": ["In Stock", "คงเหลือในคลัง"],
  "StockOnHandReport.status.checkedOut": ["Checked Out", "ถูกนำออก"],
  "StockOnHandReport.status.lost": ["Lost", "สูญหาย"],
  "StockOnHandReport.status.sold": ["Sold", "ขายแล้ว"],
  "StockOnHandReport.status.unsellable": ["Unsellable", "ขายไม่ได้"],
  "StockOnHandReport.status.voided": ["Voided", "ยกเลิก"],

  // ── RFID tag options ────────────────────────────────────
  "StockOnHandReport.rfid.tagged": ["Tagged", "ติดแท็กแล้ว"],
  "StockOnHandReport.rfid.untagged": ["Untagged", "ยังไม่ติดแท็ก"],

  // ── Table column headers ─────────────────────────────────
  "StockOnHandReport.column.wine": ["Wine", "ไวน์"],
  "StockOnHandReport.column.type": ["Type", "ประเภท"],
  "StockOnHandReport.column.location": ["Location", "ตำแหน่ง"],
  "StockOnHandReport.column.qty": ["Quantity", "จำนวน"],
  "StockOnHandReport.column.qtyIn": ["In", "คงเหลือ"],
  "StockOnHandReport.column.qtyOut": ["Out", "ถูกนำออก"],
  "StockOnHandReport.column.qtyLost": ["Lost", "สูญหาย"],
  "StockOnHandReport.column.qtyTotal": ["Total", "ทั้งหมด"],
  "StockOnHandReport.column.rfid": ["RFID", "RFID"],
  "StockOnHandReport.column.value": ["Value", "มูลค่า"],
  "StockOnHandReport.column.lastMovement": ["Last Movement", "เคลื่อนไหวล่าสุด"],
  "StockOnHandReport.column.lastAudit": ["Last Audit", "ตรวจนับล่าสุด"],
};
